import { VizType } from "@atlas-int/data";
import { useNavigate, useLocation } from "react-router";
import { googleAnalyticsCustomEvent } from "../../../sharedUtilities/analytics";
import {
  primarySelections,
  getDefaults,
  serializeParams,
  useExploreParams,
} from "../../../visualization/paramSchemas";

export const useDefaultSettingsAction = (vizType: VizType) => {
  const [query] = useExploreParams();
  const navigate = useNavigate();
  const location = useLocation();

  const defaults = getDefaults(vizType) as Record<string, unknown>;
  const defaultParams = new URLSearchParams(
    Object.entries(query)
      .filter(
        ([k, v]) =>
          primarySelections.includes(k as typeof primarySelections[number]) &&
          String(defaults[k]) !== String(v),
      )
      .map(([k, v]) => [k, String(v)]),
  );

  // Product class is a top-level control (not in the settings dropdown). Keep it
  // in the URL when non-default so reset-to-defaults does not clear it to HS92.
  const serialized = serializeParams(vizType, query);
  const pc = serialized.get("productClass");
  if (pc !== null) {
    defaultParams.set("productClass", pc);
  }

  return () => {
    googleAnalyticsCustomEvent("viz", "reset", "settings", "explore");
    navigate(`${location.pathname}?${defaultParams.toString()}`);
  };
};
